import { defineStore } from "pinia";

import { getParentCategoriesHttp, getCldCategoriesHttp } from "../api/category";
import { useUtilityStore } from "./UtililityStore";
import { REDIS_KEYS } from "~~/shared/utils/redisKeys";

export const useCategoryStore = defineStore("category", () => {
  const utilityStore = useUtilityStore();
  const selectedLanguage = computed(() => utilityStore.selectedLanguage);
  let categoryFilters = ref([]);
  const fullCategoryFilters = ref([]);
  const externalCategorySelectFilters = useState(
    "externalCategorySelectFilters",
    () => []
  );
  const categoryLables = ref({});
  const loading = ref(false);
  const parentCategories = ref([]);
  const parentCategoriesObj = ref({});
  const parentCategoryLables = ref([]);
  const parentCategoriesWithPromo = ref([]);
  const cldCategories = ref([]);

  const getCategoryFilters = async (searchProductDto) => {
    const url = useURLs[NODE_ENV].CATEGORY_FILTERS_URL;
    const { data } = await useFetchApi(
      url,
      {
        // key: prefix,
        method: "POST",
        body: searchProductDto,
        headers: {
          client_id: useURLs[NODE_ENV].CLIENT_ID,
          client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
          "Content-Type": "application/json",
        },
        retry: 1,
      },
      false
    );
    return data;
  };
  const setCategoryFilters = (v) => {
    categoryFilters.value = v;
  };
  const searchCategories = async (searchProductDto) => {
    getCategoryFilters(searchProductDto).then((response) => {
      if (response.value && response.value?.length) {
        externalCategorySelectFilters.value = response.value;
      }
    });
    genCategoryLables();
    return true;
  };
  const fetchAllCategories = async () => {
    // loading.value = true;

    const fromCache = await getRedis("ALL_CATEGORIES");
    if (fromCache && fromCache?.length) {
      fullCategoryFilters.value = fromCache;
    }

    const response = await getCategoryFilters({
      sortOrder: [],
      prefix: "",
      range: 10,
      startRowIndex: 1,
      filters: { attribute: {}, categories: [] },
      selectedLanguage: selectedLanguage.value,
      priceMin: 0,
      priceMax: 999999999,
      searchByMultiIds: { active: false, ids: [] },
    });
    if (response.value && response.value?.length) {
      fullCategoryFilters.value = response.value;
      setRedis({ key: "ALL_CATEGORIES", value: response.value });
    }
    genCategoryLables().then();
    return true;
    // loading.value = false;
  };
  const genCategoryLables = async () => {
    getRedis(REDIS_KEYS.CATEGORY_COMPUTED_LABELS).then(
      (fromCache) => {
        if (fromCache && Object.keys(fromCache).length) {
          // console.log("fromCache category", fromCache);
          categoryLables.value = fromCache;
        }
      }
    );

    // setTimeout(async () => {
    if (fullCategoryFilters.value?.length) {
      let languageDictionary = {};

      fullCategoryFilters.value.forEach((categoryFilter) => {
        categoryFilter.parent_top_hits.hits.hits[0]._source.Values.category_tree[0].Data.forEach(
          (cat) => {
            let c1 = {};

            if (cat.Childrens.length > 0) {
              c1 = {
                [cat.Childrens[0].Code]: cat.Childrens[0].Labels,
              };

              if (cat.Childrens[0].Childrens.length > 0) {
                c1 = {
                  ...c1,
                  [cat.Childrens[0].Childrens[0].Code]:
                    cat.Childrens[0].Childrens[0].Labels,
                };
              }
            }

            categoryFilter.child_agg.buckets.forEach((bucket) => {
              bucket.parent_top_hits.hits.hits[0]._source.Values.category_tree[0].Data.forEach(
                (cat2) => {
                  if (cat2.Childrens.length > 0) {
                    c1 = {
                      ...c1,
                      [cat2.Childrens[0].Code]: cat2.Childrens[0].Labels,
                    };

                    if (cat2.Childrens[0].Childrens.length > 0) {
                      c1 = {
                        ...c1,
                        [cat2.Childrens[0].Childrens[0].Code]:
                          cat2.Childrens[0].Childrens[0].Labels,
                      };
                    }
                  }
                }
              );

              if (bucket.sub_child_agg && bucket.sub_child_agg.buckets) {
                bucket.sub_child_agg.buckets.forEach((subBucket) => {
                  subBucket.parent_top_hits.hits.hits[0]._source.Values.category_tree[0].Data.forEach(
                    (cat3) => {
                      if (cat3.Childrens.length > 0) {
                        c1 = {
                          ...c1,
                          [cat3.Childrens[0].Code]: cat3.Childrens[0].Labels,
                        };

                        if (cat3.Childrens[0].Childrens.length > 0) {
                          c1 = {
                            ...c1,
                            [cat3.Childrens[0].Childrens[0].Code]:
                              cat3.Childrens[0].Childrens[0].Labels,
                          };
                        }
                      }
                    }
                  );
                });
              }
            });

            languageDictionary = {
              ...languageDictionary,
              [cat.Code]: cat.Labels,
              ...c1,
            };
          }
        );
      });

      // console.log("assigning the CATEGORY_COMPUTED_LABELS ");
      categoryLables.value = {
        ...categoryLables.value,
        ...languageDictionary,
      };
      setRedis({
        key: REDIS_KEYS.CATEGORY_COMPUTED_LABELS,
        value: categoryLables.value,
      }).then();
      return categoryLables.value;
      // console.log("settled CATEGORY_COMPUTED_LABELS in cache");
    }
    // }, 1000);
  };
  const genParentCategoryLables = async () => {
    if (parentCategories.value.length) {
      let languageDictionary = {};

      parentCategories.value.forEach((categoryFilter) => {
        categoryFilter.parent_top_hits.hits.hits[0]._source.Values.category_tree[0].Data.forEach(
          (cat) => {
            let c1 = {};

            if (cat.Childrens.length > 0) {
              c1 = {
                [cat.Childrens[0].Code]: cat.Childrens[0].Labels,
              };

              if (cat.Childrens[0].Childrens.length > 0) {
                c1 = {
                  ...c1,
                  [cat.Childrens[0].Childrens[0].Code]:
                    cat.Childrens[0].Childrens[0].Labels,
                };
              }
            }

            languageDictionary = {
              ...languageDictionary,
              [cat.Code]: cat.Labels,
              ...c1,
            };
          }
        );
      });
      parentCategoryLables.value = languageDictionary;
      // console.log("parentCategoryLables.value", parentCategoryLables.value);
    }
  };

  const getParentCategories = async () => {
    const data = await getParentCategoriesHttp();
    // console.log("data", data);
    if (!data.value && !data.value?.length) {
      console.error("Error in fetching parent categories");
    }
    parentCategories.value = data.value;
    parentCategoriesObj.value = {
      ...Object.assign(
        {},
        ...data.value?.map((x) => {
          return {
            [x.key]: { ...x },
          };
        })
      ),
    };
    await genParentCategoryLables();
  };
  const getCategoriesPromo = async () => {
    try {
      const url = useURLs[NODE_ENV].CATEGORY_PROMO_MENU;
      
      const directResponse = await fetch(url, {
        method: "GET",
        headers: {
          client_id: useURLs[NODE_ENV].CLIENT_ID,
          client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
          "Content-Type": "application/json",
        },
      });
      
      if (!directResponse.ok) {
        console.warn(" Failed to fetch promo categories:", directResponse.status);
        parentCategoriesWithPromo.value = [];
        return;
      }
      
      const directData = await directResponse.json();
      
      if (!directData) {
        console.warn(" No data returned from promo menu API");
        parentCategoriesWithPromo.value = [];
        return;
      }
      
      const categoriesArray = Array.isArray(directData) ? directData : (directData?.data || directData?.categories || []);
      
      const filtered = (categoriesArray || []).filter(category => 
        category && category.key && category.doc_count && category.doc_count > 0
      );
      
      parentCategoriesWithPromo.value = filtered;
      
    } catch (err) {
      console.error(" Error loading promo categories:", err);
      parentCategoriesWithPromo.value = [];
    }
  };

  const getCldCategories = async () => {
    const cateData = await getCldCategoriesHttp();
    if (cateData.value && cateData.value?.length) {
      // filtering  out legacy 'Archives' category
      cldCategories.value = cateData.value.filter((x) => x.id !== "MU1TRLRMLV");
    }
  };

  //#region Setters
  const setExternalCategorySelectFilters = (v) => {
    externalCategorySelectFilters.value = v;
  };
  //#endregion
  return {
    categoryFilters,
    fullCategoryFilters,
    externalCategorySelectFilters,
    setExternalCategorySelectFilters,
    categoryLables,
    loading,
    searchCategories,
    fetchAllCategories,
    getParentCategories,
    parentCategoryLables,
    parentCategories,
    parentCategoriesObj,
    genCategoryLables,
    getCategoriesPromo,
    parentCategoriesWithPromo,
    getCldCategories,
    cldCategories,
    setCategoryFilters,
  };
});
